// Google Calendar helpers — génère des URLs "TEMPLATE" (pas d'OAuth requis).
// `authuser` (email) est un hint pour que Google Calendar pré-sélectionne
// le compte connecté correspondant au mail de l'utilisateur.

function pad(n) { return String(n).padStart(2, "0"); }

function fmtAllDay(iso) {
  return iso.replace(/-/g, "");
}

function addDaysISO(iso, n) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function fmtDateTime(isoDate, hhmm) {
  // Renvoie YYYYMMDDTHHmmSS (heure locale, pas de suffixe Z)
  const [h, m] = (hhmm || "00:00").split(":");
  return `${fmtAllDay(isoDate)}T${pad(h)}${pad(m)}00`;
}

export function buildGoogleCalendarUrl({
  title,
  allDay = false,
  startDate,   // ISO "YYYY-MM-DD"
  endDate,     // ISO "YYYY-MM-DD" (inclusif). Optionnel : par défaut = startDate.
  startTime,   // "HH:MM" (si !allDay)
  endTime,     // "HH:MM" (si !allDay)
  description = "",
  location = "",
  authUserEmail = "",
}) {
  const params = new URLSearchParams();
  params.set("action", "TEMPLATE");
  params.set("text", title);

  if (allDay) {
    const s = fmtAllDay(startDate);
    // Pour Google Calendar en all-day, la date de fin est exclusive.
    const lastDay = endDate || startDate;
    const eExclusive = fmtAllDay(addDaysISO(lastDay, 1));
    params.set("dates", `${s}/${eExclusive}`);
  } else {
    params.set("dates", `${fmtDateTime(startDate, startTime)}/${fmtDateTime(endDate || startDate, endTime)}`);
  }

  if (description) params.set("details", description);
  if (location) params.set("location", location);

  const base = "https://calendar.google.com/calendar/render";
  const authParam = authUserEmail ? `&authuser=${encodeURIComponent(authUserEmail)}` : "";
  return `${base}?${params.toString()}${authParam}`;
}

// Ouvre chaque URL dans un nouvel onglet (usage : après un clic utilisateur
// pour éviter le blocage des popups).
export function openCalendarUrls(urls) {
  for (const u of urls) {
    window.open(u, "_blank", "noopener,noreferrer");
  }
}
